<template>
  <div class="login-container">
    <div class="card">
      <p class="set-password-title">Change Password</p>
      <el-form
        ref="form"
        :rules="rules"
        class="form-container"
        :model="formData">
        <div class="form-item">
          <span>Current Password</span>
          <el-form-item prop="current_password">
            <v-input
              v-model="formData.current_password"
              type="password"
              @keyEnter="changePassword"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>New Password</span>
          <el-form-item  prop="new_password">
            <v-input
              v-model="formData.new_password"
              type="password"
              @keyEnter="changePassword"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Confirm Password</span>
          <el-form-item prop="confirm_password">
            <v-input
              v-model="formData.confirm_password"
              type="password"
              @keyEnter="changePassword" />
          </el-form-item>
        </div>
      </el-form>
      <div
        align="right"
        class="right-button">
        <v-button
          type="success"
          @click="changePassword">Save</v-button>
      </div>
    </div>
  </div>
</template>
<script>
import {changePassword} from '@/api/account'
import MixinRules from '@/mixins/rules'

export default {
  name: 'changePassword',
  mixins: [MixinRules],
  data() {
    return {
      // 2991349941@qq.com
      formData:{
        new_password: '',
        current_password: '',
        confirm_password: ''
      },
      extraRules: {
        new_password: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        current_password: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        confirm_password: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
      }
      // 12345678
    }
  },
  methods: {
    changePassword() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.network().changePassword()
        }
      })
    },
    network() {
      return {
        changePassword: async () => {
          const { data } = await changePassword({
            ...this.formData
          })
          this.$message({
            type:'success',
            message:'修改密碼成功'
          })
          // localStorage.removeItem('token')
          // localStorage.removeItem('refresh_token')
          // localStorage.removeItem('auth')
          // this.$router.replace('/login')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  display: flex;
  flex-direction: column;
  //align-items: center;
  //justify-content: center;
  width: 100vw;
  height: 100vh;
  background: #fff;
  .card {
    //padding: 100px 0;
    margin: 30px;
    width: 500px;
    text-align: center;
    box-shadow: none;
    position: relative;
    .set-password-title{
      font-weight: 600;
      font-size: 24px;
      line-height: 36px;
      letter-spacing: 0.3px;
      color: #24292E;
      text-align: left;
      margin-bottom: 20px;
    }
    .form-item {
      margin: 0 auto;
      width: 500px;
      padding-bottom: 20px;
      & > span {
        text-align: left;
      }
    }
    .right-button{
      width: inherit;
      margin-top: 40px;
      .el-button{
        //width: 100%;
        //font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        //display: flex;
        //align-items: center;
        letter-spacing: -0.15px;
        color: #FFFFFF;
        background: #2EA44F;
        border: 1px solid rgba(27, 31, 35, 0.15);
        box-sizing: border-box;
        box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
        border-radius: 6px;
        &--success:hover {
          background: #2EA44F;
          opacity: 0.8;
          border-color: rgba(27, 31, 35, 0.15);
        }
      }
    }

  }
}
</style>
